<template>

<div class="filter">

    <slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.filter {
    margin-bottom: 30px;
    display: flex;
    height: 32px;
    align-items: center;
}

</style>
